import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import LegacyRoute from '../legacy-route';
import SmartSendBookedItems from '../my-orders/booked-items';
import InTransit from '../my-orders/orders-intransit';
import Addresses from '../addresses/addresses';
import MyDetailsRoute from '../my-details/my-details';
import CommunicationsRoute from '../communications/communications';
import PrePayRoute from '../prepay/prepay';
import InvoicesRoute from '../billing/invoices';
import StoredCardsRoute from '../stored-cards/stored-cards';
import { childrenOfSupport } from './support';
import ConsumerOrdersLayout from '../layouts/my-account/consumer-orders-layout';
import ConsumerAccountLayout from '../layouts/my-account/consumer-account-layout';
import ConsumerPrePayLayout from '../layouts/my-account/consumer-prepay-layout';
import ConsumerTitledLayout from '../layouts/my-account/consumer-titled-layout';
import SupportLayout from '../layouts/my-account/support';
import AutoTopUpRoute from '../auto-topup/auto-topup';

// Route tree for the consumer "My Account" experience (under the `account/` segment).
// IA per the CXA brief: My Orders / Support / Communications / PrePay & Balance / Account.
// Everything reuses existing components - no new functionality. Claims & Surcharges live
// inside Support; My Details & Saved Addresses live inside Account.
export const consumerRoutes = [
  // Land on My Orders
  {
    index: true,
    element: <LegacyRoute r={RoutingConstants.OrderHistory} />
  },
  // My Orders area - tabs: My Orders + Orders in Transit (existing lists, underline tabs + count)
  {
    element: <ConsumerOrdersLayout />,
    children: [
      { path: RoutingConstants.OrderHistory, element: <SmartSendBookedItems /> },
      { path: RoutingConstants.InTransit, element: <InTransit /> }
    ]
  },
  // Support area - reuse the existing Support layout: Home / Tickets / Claims / Surcharges
  {
    element: <SupportLayout />,
    children: childrenOfSupport
  },
  // Account area - tabs: My Details + Saved Addresses + Billing (Invoices) + Stored
  // Cards (route always registered; the tab and nav links are gated by the
  // 'StoredCards' feature flag, matching the dark-release pattern)
  {
    element: <ConsumerAccountLayout />,
    children: [
      { path: RoutingConstants.MyDetails, element: <MyDetailsRoute /> },
      { path: RoutingConstants.SavedAddresses, element: <Addresses /> },
      { path: RoutingConstants.Billing, element: <InvoicesRoute /> },
      { path: RoutingConstants.StoredCards, element: <StoredCardsRoute /> }
    ]
  },
  // PrePay area - tabs: PrePay & Balance + Auto Top-Up (the Auto Top-Up route is
  // always registered; the tab and nav links are gated by the 'AutoTopUp' feature
  // flag, matching the dark-release pattern)
  {
    element: <ConsumerPrePayLayout />,
    children: [
      { path: RoutingConstants.PrePay, element: <PrePayRoute /> },
      { path: RoutingConstants.AutoTopUp, element: <AutoTopUpRoute /> }
    ]
  },
  // Standalone titled pages
  {
    element: <ConsumerTitledLayout />,
    children: [{ path: RoutingConstants.Communications, element: <CommunicationsRoute /> }]
  }
];
